import Vue from 'vue'
import Router from 'vue-router'
import PortalLayout from '@/layout/PortalLayout.vue'
import { isAuthenticated, isScopedAuthenticated } from '@/utils/auth'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: PortalLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/HomePage.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: 'scores',
        name: 'ScoreList',
        component: () => import('@/views/ScoreListPage.vue'),
        meta: {
          title: '成绩列表',
          requiresAuth: true
        }
      },
      {
        path: 'scores/:candidateId',
        name: 'ScoreDetail',
        component: () => import('@/views/ScoreDetailPage.vue'),
        meta: {
          title: '成绩详情',
          requiresAuth: true
        }
      },
      {
        path: 'certificate/:certNo',
        name: 'CertificateDetail',
        component: () => import('@/views/CertificateDetailPage.vue'),
        meta: {
          title: '证书查询'
        }
      },
      {
        path: 'post-ability',
        name: 'PostAbilityQuery',
        component: () => import('@/views/PostAblitityQueryPage.vue'),
        meta: {
          title: '岗位能力成绩查询'
        }
      },
      {
        path: 'post-ability/scores/:candidateId',
        name: 'PostAbilityScoreDetail',
        component: () => import('@/views/PostAblitityScoreDetailPage.vue'),
        meta: {
          title: '岗位能力成绩详情',
          requiresAuth: true,
          authScope: 'postAbility'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta && record.meta.requiresAuth)
  const authScope = to.meta && to.meta.authScope ? to.meta.authScope : 'default'
  const hasAuth = authScope === 'default' ? isAuthenticated() : isScopedAuthenticated(authScope)
  if (requiresAuth && !hasAuth) {
    next({
      path: authScope === 'postAbility' ? '/post-ability' : '/',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }

  next()
})

router.afterEach((to) => {
  const pageTitle = to.meta && to.meta.title
    ? `${to.meta.title} - 全国社会艺术水平等级考试`
    : '全国社会艺术水平等级考试'
  document.title = pageTitle
})

export default router
